import BaseApiAction from '@Actions/base-api-action';
import { isUndefined } from 'lodash-es';

export default class UpdateResults extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'sessions-updateResults',
      payload: {
        ...this._payload,
        // HACK: Remove is_late_critical from scan_events, as it is not a valid column in the database
        scan_events: this._payload.scan_events.map((scanEvent: any) => {
          const newScanEvent = { ...scanEvent };
          if (!isUndefined(newScanEvent.is_late_critical)) {
            delete newScanEvent.is_late_critical;
          }
          return newScanEvent;
        }),
      }
    });
  }
}